export const BUSINESS_NAME = 'Αερικό'